import React from 'react';
import PropTypes from 'prop-types';
import { Slider } from '@mui/material';



export const CustomSlider = ({ onChange, ...rest }) => {

    const handleOnChange = (e, value) => {
        onChange({
            target: {
                name: rest?.name,
                type: rest?.type,
                value
            }
        })
    }

    rest.value = parseFloat(rest.value);

    return (
        <Slider
            {...rest}
            type='number'
            valueLabelDisplay="auto"
            onChange={handleOnChange}
        />
    )
}

CustomSlider.propTypes = {
    onChange: PropTypes.func.isRequired,
}